import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ParticleHeroBackdrop } from './ui/particle-hero-backdrop';
import './ParticleHero.css';

const ParticleHero = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { scrollY } = useScroll();
  const contentY = useTransform(scrollY, [0, 600], [0, -120]);
  const contentOpacity = useTransform(scrollY, [0, 400], [1, 0]);
  const bgY = useTransform(scrollY, [0, 800], [0, 200]);

  return (
    <section className="particle-hero">
      <motion.div className="particle-hero-bg" style={{ y: bgY }}>
        <ParticleHeroBackdrop />
        <div className="particle-hero-vignette" />
      </motion.div>

      <motion.div
        className="particle-hero-content"
        style={{ y: contentY, opacity: contentOpacity }}
      >
        <motion.div
          className="particle-hero-eyebrow"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="particle-hero-dot" />
          <span>{t('home.hero.eyebrow')}</span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.1 }}
        >
          {t('home.hero.title')}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.25 }}
        >
          {t('home.hero.subtitle')}
        </motion.p>

        <motion.div
          className="particle-hero-cta"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.4 }}
        >
          <motion.button
            className="particle-cta primary"
            onClick={() => navigate('/start-project')}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
          >
            {t('home.hero.cta')}
          </motion.button>
          <motion.button
            className="particle-cta secondary"
            onClick={() => navigate('/services')}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
          >
            {t('home.hero.seeWork')}
          </motion.button>
        </motion.div>

        <motion.div
          className="particle-hero-stats"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.55 }}
        >
          <div className="particle-stat">
            <span className="particle-stat-num">{t('home.hero.stats.fastValue')}</span>
            <span className="particle-stat-label">{t('home.hero.stats.fastLabel')}</span>
          </div>
          <div className="particle-stat">
            <span className="particle-stat-num">{t('home.hero.stats.affordableValue')}</span>
            <span className="particle-stat-label">{t('home.hero.stats.affordableLabel')}</span>
          </div>
          <div className="particle-stat">
            <span className="particle-stat-num">100%</span>
            <span className="particle-stat-label">{t('home.hero.stats.satisfaction')}</span>
          </div>
        </motion.div>
      </motion.div>

      <motion.div
        className="particle-hero-scroll"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 1 }}
        style={{ opacity: contentOpacity }}
      >
        <span className="particle-hero-scroll-label">{t('home.hero.scroll')}</span>
        <span className="particle-hero-scroll-line" />
      </motion.div>
    </section>
  );
};

export default ParticleHero;
